import {
  _resendEntityInvitation,
  _resendEntityShareholderInvitation,
  _revokeEntityInvitation,
} from '../entity/mutations';
import { _resendFundShareholderInvitation } from '../fund/mutations';
import { _resendGammaTeamInvitation, _revokeGammaTeamInvitation } from '../gamma-team/mutations';
import { AdminDashboardInvitationType } from './types';

type ResendAdminInvitationParams = {
  email: string;
  invitationType: AdminDashboardInvitationType;
};

export const _resendAdminInvitation = ({ email, invitationType }: ResendAdminInvitationParams) => {
  switch (invitationType) {
    case AdminDashboardInvitationType.GammaTeam:
      return _resendGammaTeamInvitation({ email });
    case AdminDashboardInvitationType.Entity:
      return _resendEntityInvitation({ email });
    case AdminDashboardInvitationType.EntityShareholder:
      return _resendEntityShareholderInvitation({ email });
    case AdminDashboardInvitationType.FundShareholder:
      return _resendFundShareholderInvitation({ email });
  }
};

type DeleteAdminInvitationParams = {
  email: string;
  invitationTypes: AdminDashboardInvitationType[];
};

export const isRevocableInvitationType = (
  invitationType: AdminDashboardInvitationType | null,
): boolean =>
  invitationType === AdminDashboardInvitationType.GammaTeam ||
  invitationType === AdminDashboardInvitationType.Entity;

export const revocableInvitationTypes = (
  invitationTypes: AdminDashboardInvitationType[],
): AdminDashboardInvitationType[] => invitationTypes.filter(isRevocableInvitationType);

export const _deleteAdminInvitation = async ({
  email,
  invitationTypes,
}: DeleteAdminInvitationParams) => {
  const revocable = revocableInvitationTypes(invitationTypes);

  if (revocable.length === 0) {
    throw new Error(
      `No revocable invitation for this row (${invitationTypes.join(', ') || 'none'})`,
    );
  }

  for (const invitationType of revocable) {
    if (invitationType === AdminDashboardInvitationType.GammaTeam) {
      await _revokeGammaTeamInvitation({ email });
    } else {
      await _revokeEntityInvitation({ email });
    }
  }
};
